var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup337(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_337",
    "data-name": "Group 337",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.941,
    height: 14.891,
    viewBox: "0 0 14.941 14.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 14.941,
    height: 14.891,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M153.473,4.787a1.34,1.34,0,0,1-1.335-1.321,1.365,1.365,0,0,1,1.327-1.342,1.388,1.388,0,0,1,1.342,1.338,1.34,1.34,0,0,1-1.334,1.326",
    transform: "translate(-146.007 -2.038)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M262.18,80.5a1,1,0,0,1-.976,1.015,1.005,1.005,0,0,1-.016-2.01.983.983,0,0,1,.993,1",
    transform: "translate(-249.709 -76.298)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M62.545,80.523a1,1,0,0,1-2.007-.018A1.023,1.023,0,0,1,61.562,79.5a1.047,1.047,0,0,1,.983,1.026",
    transform: "translate(-58.098 -76.293)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.968,3.98Q1.8,5.186,2.634,6.391a2.184,2.184,0,0,1,.4,1.28c-.005,1.074-.008,2.148,0,3.222a5.222,5.222,0,0,0,.05,1.271c.033.128-.047.151-.144.155-.193.006-.388,0-.58.016-.337.033-.461.163-.485.5-.01.135-.012.27-.01.405H14.527c0-.05,0-.1,0-.15-.008-.65-.12-.762-.76-.767h-.116c-.365,0-.361,0-.309-.346a2.542,2.542,0,0,0,.018-.376q0-1.988,0-3.976a2.026,2.026,0,0,1,.335-1.153c.36-.539.739-1.065,1.106-1.6.258-.374.517-.748.76-1.131a.353.353,0,0,0-.114-.53.359.359,0,0,0-.513.1c-.085.106-.164.216-.241.327q-.639.916-1.276,1.834a.857.857,0,0,1-.736.393c-.319,0-.639,0-.958,0a.789.789,0,0,1-.668-.347c-.218-.308-.425-.624-.655-.923a.371.371,0,0,1,0-.515c.583-.819,1.154-1.648,1.726-2.476.192-.278.386-.557.559-.848A.5.5,0,0,0,12.52.093a.508.508,0,0,0-.677.1,2.8,2.8,0,0,0-.176.231q-.944,1.358-1.885,2.718a1.044,1.044,0,0,1-.733.472A7.182,7.182,0,0,1,7.4,3.633a1.077,1.077,0,0,1-.808-.507C5.965,2.208,5.327,1.3,4.693.382,4.428,0,4.135-.1,3.852.1s-.286.493-.032.868l.032.048C4.574,2.057,5.293,3.1,6.021,4.137a.305.305,0,0,1,0,.415,8.094,8.094,0,0,0-.512.739A1.125,1.125,0,0,1,4.4,5.878C3.233,5.854,3.234,5.87,2.573,4.9c-.36-.527-.722-1.053-1.093-1.573a.378.378,0,0,0-.557-.109.39.39,0,0,0-.1.543,2.488,2.488,0,0,0,.143.219m8.642,8.154a1.019,1.019,0,0,0,.09-.565q0-2.768,0-5.537A1.54,1.54,0,0,1,9.858,5.2c.567.862,1.3,1.579,1.249,2.717-.056,1.254-.013,2.512-.013,3.768,0,.077,0,.155,0,.232.019.4.019.4-.4.4-.319,0-.638,0-.957,0-.139,0-.24-.009-.127-.189m-4.355.026a2.544,2.544,0,0,0,.038-.72c0-1.227.006-2.453,0-3.68a2.342,2.342,0,0,1,.438-1.413c.23-.322.451-.651.678-.975.032-.046.055-.119.12-.112.086.01.077.1.093.159a2.5,2.5,0,0,1,.065.632q0,1.376,0,2.752,0,1.434,0,2.868a.89.89,0,0,0,.061.426c.087.166.036.227-.143.225-.4,0-.792,0-1.188,0-.1,0-.2-.01-.16-.161",
    transform: "translate(-0.727 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.117,341.565c0,.006-.008.011-.011.018a1.072,1.072,0,0,0-.027.871c.093.256.345.237.572.236H14.234a2.578,2.578,0,0,0,.29-.006.407.407,0,0,0,.385-.37c.061-.37.041-.605-.093-.747Z",
    transform: "translate(0 -327.8)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup337);
export default __webpack_public_path__ + "static/media/Group337.fb62a35b776046bcf4cbd9b3a717da70.svg";
export { ForwardRef as ReactComponent };